const topics = [
  { tag: '国漫崛起', heat: '9.8万讨论', desc: '国产漫画质量飞跃引发全网热议，多部作品动画化确认', icon: 'ri-rocket-line' },
  { tag: '新番开坑', heat: '7.2万讨论', desc: '七月新番陆续上线，多部人气轻小说改编漫画值得期待', icon: 'ri-sparkling-line' },
  { tag: '日漫经典重温', heat: '6.5万讨论', desc: '经典老番重读热潮，那些年追过的漫画现在再看依旧感动', icon: 'ri-book-open-line' },
  { tag: '悬疑推理漫', heat: '5.8万讨论', desc: '烧脑剧情控必追，反转不断的悬疑漫画推荐合集', icon: 'ri-search-eye-line' },
  { tag: '恋爱日常番', heat: '5.3万讨论', desc: '甜蜜治愈系漫画大盘点，从校园到职场总有你的菜', icon: 'ri-heart-line' },
  { tag: '热血战斗漫', heat: '4.9万讨论', desc: '燃到爆的战斗场面，这些漫画的打斗分镜堪称教科书', icon: 'ri-sword-line' },
  { tag: '週刊連載速報', heat: '4.6万讨论', desc: '每周连载进度同步，JUMP系漫画最新话讨论集中地', icon: 'ri-flashlight-line' },
  { tag: '漫改动画对比', heat: '4.2万讨论', desc: '动画化后的漫画还原度大讨论，哪些改编超越了原作', icon: 'ri-tv-line' },
  { tag: '冷门佳作挖掘', heat: '3.9万讨论', desc: '小众但质量超高的漫画推荐，每一部都值得细细品味', icon: 'ri-star-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            热议话题
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            漫友们正在热火朝天讨论的漫画追更话题，看看大家都在关注什么
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#topics"
              className="group flex items-start gap-4 p-5 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                <i className={`${topic.icon} text-primary-500 text-lg`}></i>
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1.5">
                  <h3 className="text-base font-semibold text-foreground-900 whitespace-nowrap">{topic.tag}</h3>
                  <span className="text-xs font-medium text-primary-500 bg-primary-100 px-2 py-0.5 rounded-full whitespace-nowrap">{topic.heat}</span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{topic.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}